export default {
  title: 'Notificações push',
  description: 'Envie notificações push direcionadas aos seus clientes',
  buttons: {
    new_campaign: 'Nova campanha',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Aplicação móvel ainda não está ativa',
      description: 'Aguarde que a aplicação móvel esteja ativa antes de enviar notificações push',
    },
  },
};
